import { useDefaultAsset } from '@onramp/v2/client/views/guest/onramp/hooks/useDefaultAsset';
import { useOnrampInputStoreValue } from '@onramp/v2/client/views/onramp/state/store';

export const useOnrampActiveAsset = () => {
  const { selectedAsset } = useOnrampInputStoreValue();
  const defaultAsset = useDefaultAsset();

  return selectedAsset ?? defaultAsset;
};
